import './components/headerMenu';
import './components/slider';
import './components/bottomSlider';
import './components/lightbox';
import './components/lightbox-realizations';
import './components/animations';